export default __webpack_public_path__ + "static/media/puppyMalePink.ec4e0079.jpg";